import { FC } from 'react';
import cn from 'classnames';

interface TextSkeletonProps {
  size?: 'sm' | 'md';
  paragraphs?: number;
  linesPerParagraph?: 1 | 2 | 3 | 4;
  className?: string;
}

const widths = ['w-3/4', 'w-2/3', 'w-4/5', 'w-1/2'];

/**
 * Display a skeleton placeholder for text.
 * Allows to generate multiple paragraphs and multiple rows per paragraph
 */
export const TextSkeleton: FC<TextSkeletonProps> = ({
  size = 'md',
  paragraphs = 1,
  linesPerParagraph = 4,
  className,
}) => {
  const height = size === 'md' ? 'h-4' : 'h-3';

  return (
    <div className={cn('flex flex-col gap-4', className)}>
      {Array.from({ length: paragraphs }).map((_, paragraphIndex) => (
        <div key={paragraphIndex} className="flex flex-col gap-2.5">
          {Array.from({ length: linesPerParagraph }).map((_, lineIndex) => {
            const width = widths[lineIndex % widths.length];
            // Hide the 4th line on mobile to mimic the original layout
            const visibility = lineIndex === 3 ? 'hidden lg:block' : '';
            return (
              <div
                key={lineIndex}
                className={cn(
                  'bg-grey-100 shrink-0 animate-pulse rounded-2xl',
                  width,
                  height,
                  visibility
                )}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};
